<script setup lang="ts"></script>

<template>
  <NuxtLinkLocale
    to="/cards/rating"
    class="relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] p-4 text-white transition-all duration-500 ease-out hover:from-[#1D4ED8] hover:to-[#60A5FA]"
  >
    <NuxtImg
      src="/images/photostock/cards.png"
      alt="Background"
      class="absolute bottom-[-20px] right-[-10px] z-0 object-contain transition-opacity duration-300 sm:bottom-[-5px]"
      width="170"
      height="170"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <div class="relative z-10">
      <div class="mb-3 sm:hidden">
        <NuxtImg src="/images-backup/logos/logo-white.png" alt="Logo" width="70" height="26" />
      </div>

      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3 hidden sm:block"
        width="86"
        height="32"
      />

      <h3
        class="z-10 max-w-40 text-base font-bold leading-tight sm:mb-6 sm:max-w-full sm:text-xl xl:max-w-52"
      >
        {{ $t('widget.cards.rating_cta.title') }}
      </h3>

      <div class="mb-4 hidden items-center gap-2 sm:flex">
        <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 0 0 .95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 0 0-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 0 0-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 0 0-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 0 0 .951-.69l1.519-4.674z"
              fill="#1E3A8A"
            />
          </svg>
        </div>
        <span class="text-sm font-bold">{{ $t('widget.cards.rating_cta.cta') }}</span>
      </div>
    </div>
  </NuxtLinkLocale>
</template>